import { StorageType } from "@privacyresearch/libsignal-protocol-typescript";

export default class SignalProtocolStore implements StorageType {
    public store: Map<string, any> = new Map();

    constructor() {
        // Przy starcie ładujemy wszystko z localStorage
        const saved = localStorage.getItem("signal_store");
        if (saved) {
            try {
                const parsed = JSON.parse(saved);
                this.store = new Map(Object.entries(parsed));
            } catch (e) {
                console.warn("Failed to parse localStorage signal_store", e);
            }
        }
    }

    private persist() {
        const obj: Record<string, any> = {};
        this.store.forEach((v, k) => {
            obj[k] = v;
        });
        localStorage.setItem("signal_store", JSON.stringify(obj));
    }

    // ----------- identity -----------
    async getIdentityKeyPair(): Promise<any> {
        return this.store.get("identityKey");
    }

    async getLocalRegistrationId(): Promise<number> {
        return this.store.get("registrationId");
    }

    async isTrustedIdentity(identifier: string, identityKey: any): Promise<boolean> {
        return true; // prosty trust model
    }

    async saveIdentity(identifier: string, identityKey: any): Promise<boolean> {
        this.store.set("identity_" + identifier, identityKey);
        this.persist();
        return true;
    }

    // ----------- pre keys -----------
    async loadPreKey(keyId: number | string): Promise<any | undefined> {
        return this.store.get("preKey_" + keyId);
    }

    async storePreKey(keyId: number | string, record: any): Promise<void> {
        this.store.set("preKey_" + keyId, record);
        this.persist();
    }

    async removePreKey(keyId: number | string): Promise<void> {
        this.store.delete("preKey_" + keyId);
        this.persist();
    }

    // ----------- signed pre keys -----------
    async loadSignedPreKey(keyId: number | string): Promise<any | undefined> {
        return this.store.get("signedPreKey_" + keyId);
    }

    async storeSignedPreKey(keyId: number | string, record: any): Promise<void> {
        this.store.set("signedPreKey_" + keyId, record);
        this.persist();
    }

    async removeSignedPreKey(keyId: number | string): Promise<void> {
        this.store.delete("signedPreKey_" + keyId);
        this.persist();
    }

    // ----------- sessions -----------
    async loadSession(identifier: string): Promise<any | undefined> {
        return this.store.get("session_" + identifier);
    }

    async storeSession(identifier: string, record: any): Promise<void> {
        this.store.set("session_" + identifier, record);
        this.persist();
    }

    async containsSession(identifier: string): Promise<boolean> {
        return this.store.has("session_" + identifier);
    }

    async removeSession(identifier: string): Promise<void> {
        this.store.delete("session_" + identifier);
        this.persist();
    }

    async removeAllSessions(identifier: string): Promise<void> {
        for (let key of this.store.keys()) {
            if (key.startsWith("session_" + identifier)) {
                this.store.delete(key);
            }
        }
        this.persist();
    }
}
